<template>
   <section>
      <v-container fluid>
         <!-- Header -->
         <ControlHeader :pageData="pageData" :form="form" :save="save" :valid="valid" :deleteMethod="deleteMethod" />
         <!-- End Of Header -->
         <!-- Form -->
         <v-form ref="form" v-model="valid" class="pa-5">
            <v-card class="backgroundW shadow pa-5 pt-7">
               <v-row>
                  <v-col cols="12" md="6" lg="4" class="px-0">
                     <GenericInput type="switch" :value="form.section_active"  @input="form.section_active = $event" :cols="[12, 12, 12]"
                        label="view section" :multi="false" :required="false" :isLoading="pageData.editIsLoading">
                     </GenericInput>
                     <GenericInput type="text" :value="form.code" :disabled="pageData.isEdit" @input="form.code = $event" :cols="[12, 12, 12]"
                        label="code" :multi="false" :required="true" :isLoading="pageData.editIsLoading">
                     </GenericInput>
                     <GenericInput type="file" :value="form.image_ar" @input="form.image_ar = $event"
                        :cols="[12, 12, 12]" label="صوره بالعربي" :multi="false" :required="false"
                        :isLoading="pageData.editIsLoading">
                     </GenericInput>
                     <GenericInput type="file" :value="form.image_en" @input="form.image_en = $event"
                        :cols="[12, 12, 12]" label="english image" :multi="false" :required="false"
                        :isLoading="pageData.editIsLoading">
                     </GenericInput>

                     <v-col cols="12">
                        <v-file-input outlined dense :label="$i18n.t('فديو')"
                           v-model="form.video_ar">
                        </v-file-input>
                     </v-col>
                     <v-col cols="12">
                        <v-file-input outlined dense :label="$i18n.t('video')"
                           v-model="form.video_en">
                        </v-file-input>
                     </v-col>
                  </v-col>
                  <v-col cols="1" class="pa-0 py-10 d-none d-md-block">
                     <v-divider vertical class="d-block ma-auto"></v-divider>
                  </v-col>
                  <v-col cols="12" md="6" lg="7" class="d-flex align-start">
                     <v-row align="center">
                        <GenericInput type="text" :value="form.name_ar" @input="form.name_ar = $event"
                           :cols="[12, 12, 6]" label="اسم قسم بالعربي" :multi="false" :required="false"
                           :isLoading="pageData.editIsLoading">
                        </GenericInput>
                        <GenericInput type="text" :value="form.name_en" @input="form.name_en = $event"
                           :cols="[12, 12, 6]" label="english category name" :multi="false" :required="false"
                           :isLoading="pageData.editIsLoading">
                        </GenericInput>
                        <GenericInput type="text" :value="form.title_ar" @input="form.title_ar = $event"
                           label="العنوان بالعربي" :required="false" :isLoading="pageData.editIsLoading"
                           :cols="[12, 12, 12]">
                        </GenericInput>
                        <GenericInput type="text" :value="form.title_en" @input="form.title_en = $event"
                           label="title in english" :required="false" :isLoading="pageData.editIsLoading"
                           :cols="[12, 12, 12]">
                        </GenericInput>


                        <GenericInput type="text" :value="form.link_ar" @input="form.link_ar = $event"
                           :cols="[12, 12, 6]" label="الرابط عربي" :multi="false" :required="false"
                           :isLoading="pageData.editIsLoading">
                        </GenericInput>
                        <GenericInput type="text" :value="form.link_en" @input="form.link_en = $event"
                           :cols="[12, 12, 6]" label="english link" :multi="false" :required="false"
                           :isLoading="pageData.editIsLoading">
                        </GenericInput>

                        <GenericInput type="texteditor" :value="form.description_ar"
                           @input="form.description_ar = $event" label="الوصف بالعربي" :required="false"
                           :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]">
                        </GenericInput>
                        <GenericInput type="texteditor" dir="ltr" :value="form.description_en"
                           @input="form.description_en = $event" label="description in english" :required="false"
                           :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]">
                        </GenericInput>
                        
                     </v-row>
                  </v-col>


               </v-row>


            </v-card>
         </v-form>
         <!-- End of Form -->
      </v-container>
   </section>
</template>



<script>
import GenericInput from '@/components/ui/GenericInput.vue';
import ControlHeader from "@/components/ui/ControlHeader.vue";
export default {
   name: "SectionsControl",
   data: () => ({
      pageData: {
         screen_code: "02-008",
         url: null,
         controlRoute: "website/section-control",
         entityName: null,
         main: null,
         category: null,
         isLoading: true,
         isEdit: false,
         editIsLoading: false,
      },
      valid: false,
      categories: [],
      form: {
         name_en: null,
         name_ar: null,
         title_en: null,
         title_ar: null,
         link_ar: null,
         link_en: null,
         code: null,
         description_en: null,
         description_ar: null,
         image_en: null,
         image_ar: null,
         video_en: null,
         video_ar: null,
         section_active: 1,
      }
   }),
   components: {
      ControlHeader,
      GenericInput,
   },
   computed: {
   },
   mounted() {
      this.pageMainData();
      this.formatDate();
      this.getData();
   },
   methods: {
      pageMainData() {
         this.pageData.main = this.$global.FilterPermissions(this.pageData.screen_code).main_title;
         this.pageData.category = this.$global.FilterPermissions(this.pageData.screen_code).cat_title;
         this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;
         this.pageData.entityName = this.pageData.entityName = this.$route.params.id ? this.$i18n.t("edit") + " " + this.$global.FilterPermissions(this.pageData.screen_code).sub_title : this.$i18n.t("add") + " " + this.$global.FilterPermissions(this.pageData.screen_code).sub_title;
      },
      getData() {
         if (this.$route.params.id) {
            if (this.$global.CheckAction(this.pageData.screen_code, 3)) {
               this.pageData.isEdit = true;
               this.pageData.editIsLoading = true;
               this.pageData.isLoading = true;
               this.$api.GET_METHOD(`section/${this.$route.params.id}`).then((response) => {
                  this.pageData.editIsLoading = false;
                  this.pageData.isLoading = false;
                  if (response.check) {
                     console.log("response", response);
                     this.form = response.data.data;
                     this.categories = response.data.categorys;
                     this.$refs.form.validate();
                  }
               })
            } else {
               this.$router.push('/')
            }
         }
         else {
            if (this.$global.CheckAction(this.pageData.screen_code, 2)) {

               this.pageData.isLoading = true;
               this.$api.GET_METHOD(`section/create`).then((response) => {
                  this.pageData.isLoading = false;
                  if (response.check) {
                     this.categories = response.data.categorys;
                  }
               })
            } else {
               this.$router.push('/')
            }

         }

      },
      save() {
         if (this.$refs.form.validate()) {
            this.pageData.isLoading = true;
            if (this.pageData.isEdit == true) {
               this.form._method = 'PUT';
               this.$api.POST_METHOD_MULTIPART(`section/${this.form.id}`, this.form).then((response) => {
                  this.pageData.isLoading = false;
                  if (response.check) {
                     this.$router.push(this.pageData.url)
                  }
               })
            }
            else {
               this.$api.POST_METHOD_MULTIPART(`section`, this.form).then((response) => {
                  this.pageData.isLoading = false;
                  if (response.check) {
                     this.$router.push(this.pageData.url)
                  }
               })
            }
         }
      },
      formatDate() {
         var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

         if (month.length < 2)
            month = '0' + month;
         if (day.length < 2)
            day = '0' + day;
         this.form.start_date = [year, month, day].join('-');
         this.form.end_date = [year, month, day].join('-');
      },
      deleteMethod(status) {
         if (status == true) {
            this.pageData.isLoading = true
            this.$api.POST_METHOD(`section/${this.form.id}`, { _method: 'delete' }).then(() => {
               this.$router.push(this.pageData.url);
               this.pageData.isLoading = false
            })
         }
      },


   },
};
</script>
